<template>
    <div class="all clearfix">
        <div class="fl bgff w860">
           <div class="grid">
                <div class="details">
                    <h1 class="fs34">{{artList.news_title}}</h1>
                    <div class="cr77 mt10 clearfix">
                        <div class="fl">作者：{{artList.author_name}}</div>
                        <div class="fl ml20">时间：{{artList.create_time}}</div>
                    </div>
                    <div class="details-cont fs16 mt30">{{artList.news_content}}</div>
                </div>
            </div>
        </div>
        <div class="mrCont w330 bgff fr">
            <div class="grid">
                <div class="grid-header clearfix">
                    <h2 class="title"><img src="static/images/jzTit.png"/></h2>
                </div>
                <div class="grid-body mt15">
                    <ul class="jzNews">
                        <li class="mb20" v-for="(item,index) in jzNewsList" :key="index">
                            <div class="imgText clearfix">
                                <router-link class="img fl cp" :to="{path:'pointDetail',query:{id:item.id}}"><img :src="item.picurl" :onerror="defaultImg"/></router-link> 
                                <div class="hidden">
                                    <h4 class="ovhidden3 mt5 fs14">
                                        <router-link class="cr00 cp" :to="{path:'pointDetail',query:{id:item.id}}">{{item.news_title}}</router-link>
                                    </h4>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div class="no-data pt30" v-if="nodata.jzNewsList"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            sid : this.$route.query.id,
            jzNewsList:[1,2],
            defaultImg:'this.src="static/images/default.png"',
            artList:{},//文章内容
			commendList:[],//推荐	
            nodata:{
                jzNewsList:false,
            }
        }
    },
    mounted() {
        let that = this;
        that.$nextTick(()=> {
            that.ajax();
            that.dataAjax();
        }) 
    },
    watch: {
		$route(){
            let that = this;
            that.sid = that.$route.query.id;
            that.ajax();
		},
	},
    methods: {
        ajax(){//ajax
            let that = this;
            that.$parent.loadModal(true,'数据加载中...');
            that.$api.get('viewpoint/index/info',{id:that.sid},r=>{
				that.$parent.returnCode(r,function(){
					that.$parent.loadModal(false);
					that.artList = r.data;
				})
			});
		},
        dataAjax(){
            let that = this;
            let datas={
                column:'较真'
            };
            that.$api.get('viewpoint/index/list',datas,r=>{
                that.$parent.returnCode(r,function(){
                    that.jzNewsList = r.data.list;
                    if(r.data.list.length<=0){
                        that.nodata.jzNewsList = true;
                    }else{
                        that.nodata.jzNewsList = false;
                    }
                });
            });
        },
        
	}
}
</script>



// WEBPACK FOOTER //
// src/page/point/pointDetail.vue